<template>
  <section class="dd-about">
    <div class="dd-about__card dd-wall-card">
      <h2>{{ $t('wall.tabs.about') }}</h2>
      <div v-if="visuals.description" class="dd-about__text" v-html="visuals.description"></div>
      <p v-else class="dd-about__text">Описание пока не добавлено.</p>
      <div v-if="socials.length" class="dd-about__socials">
        <a v-for="s in socials" :key="s.name" class="dd-about__social" :href="s.href" target="_blank" rel="noopener">
          <img :src="s.icon" :alt="s.name" width="18" height="18" />
          <span>{{ s.name }}</span>
        </a>
      </div>
    </div>
    <div v-if="activeSubscribersCount != null" class="dd-about__card dd-wall-card">
      <h3 class="dd-about__subtitle">Статистика</h3>
      <div class="dd-about__stats">
        <div class="dd-about__stat">
          <div class="dd-about__stat-label">Активных подписчиков</div>
          <div class="dd-about__stat-value">{{ activeSubscribersCount }}</div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'WallAbout',
  computed: {
    visuals() { return this.$store.getters.visuals || {}; },
    socials() {
      const v = this.visuals || {};
      const items = [];
      if (v.twitter) items.push({ name: 'Twitter', href: v.twitter, icon: require('@/assets/img/twitter.svg') });
      if (v.instagram) items.push({ name: 'Instagram', href: v.instagram, icon: require('@/assets/img/instagram.svg') });
      if (v.telegram) items.push({ name: 'Telegram', href: v.telegram, icon: require('@/assets/img/telegram.svg') });
      if (v.youtube) items.push({ name: 'YouTube', href: v.youtube, icon: require('@/assets/img/youtube.svg') });
      if (v.twitch) items.push({ name: 'Twitch', href: v.twitch, icon: require('@/assets/img/twitch.svg') });
      return items;
    },
    activeSubscribersCount() {
      return this.$store.getters.subscribersStats?.active_subscribers_count ?? null;
    }
  },
}
</script>

